// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-fa-input-with-text__image[data-v-65697cd3]{grid-area:image}.two-fa-input-with-text__text[data-v-65697cd3]{grid-area:text}.two-fa-input-with-text__input[data-v-65697cd3]{grid-area:input}.two-fa-input-with-text__error[data-v-65697cd3]{grid-area:error}.two-fa-input-with-text__bottom[data-v-65697cd3]{grid-area:bottom}.two-fa-input-with-text__image>img[data-v-65697cd3]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
